import { combineReducers, configureStore } from "@reduxjs/toolkit";

// Auth slices
import authSlice from "../slices/auth/authSlice";
import settingSlice from "../slices/auth/settingSlice";

// Common slices
import companyAndBrandSlice from "../slices/common/companyAndBrandSlice";
import companyIntegrationSlice from "../slices/common/companyIntegrationSlice";
import courierConfigurationSlice from "../slices/common/courierConfigurationSlice";
import commonCustomerSlice from "../slices/common/customerSlice";
import customizationChildrenSlice from "../slices/common/customizationChildrenSlice";
import customDomainSlice from "../slices/common/customDomainSlice";
import marketingSlice from "../slices/common/marketingSlice";
import quoteSlice from "../slices/common/quoteSlice";
import seoSlice from "../slices/common/seoSlice";
import subscriptionSlice from "../slices/common/subscriptionSlice";
import tenantSlice from "../slices/common/tenantSlice";
import websiteInfoSlice from "../slices/common/websiteInfoSlice";
import websiteMetaDataSlice from "../slices/common/websiteMetaDataSlice";
import websiteProductFeatureSlice from "../slices/common/websiteProductFeatureSlice";
import websiteProductSlice from "../slices/common/websiteProductSlice";

// Ecommerce slices
import adminNotifictionSlice from "../slices/ecommerce/adminNotifictionSlice";
import arShapesSlice from "../slices/ecommerce/arShapesSlice";
import commentRuleSlice from "../slices/ecommerce/commentRuleSlice";
import couponSlice from "../slices/ecommerce/couponSlice";
import courierSlice from "../slices/ecommerce/courierSlice";
import customerSlice from "../slices/ecommerce/customerSlice";
import dashboardSlice from "../slices/ecommerce/dashboardSlice";
import deliveryChargeSlice from "../slices/ecommerce/deliveryChargeSlice";
import gstSlice from "../slices/ecommerce/gstSlice";
import facebookSlice from "../slices/ecommerce/facebookSlice";
import inventorySlice from "../slices/ecommerce/inventorySlice";
import instagramSlice from "../slices/ecommerce/instagramSlice";
import offeringChildrenSlice from "../slices/ecommerce/offeringChildrenSlice";
import offeringSlice from "../slices/ecommerce/offeringSlice";
import offeringBookingReplySlice from "../slices/ecommerce/offeringBookingReplySlice";
import orderSlice from "../slices/ecommerce/orderSlice";
import ProductCustomerReviewSlice from "../slices/ecommerce/ProductCustomerReviewSlice";
import productChildrenSlice from "../slices/ecommerce/productChildrenSlice";
import productCategorySlice from "../slices/ecommerce/productCategorySlice";
import productDesignSlice from "../slices/ecommerce/productDesignSlice";
import productDiscountSlice from "../slices/ecommerce/productDiscountSlice";
import productFilterSlice from "../slices/ecommerce/productFilterSlice";
import productMetaDataSlice from "../slices/ecommerce/productMetaDataSlice";
import productPreviewSlice from "../slices/ecommerce/productPreviewSlice";
import productSlice from "../slices/ecommerce/productSlice";
import quickReplySlice from "../slices/ecommerce/quickReplySlice";
import whatsappSlice from "../slices/ecommerce/whatsappSlice";
import whatsappTemplateSlice from "../slices/ecommerce/whatsappTemplateSlice";

// Legacy/root slices
import categoryDataSlice from "../slices/categoryDataSlice";
import citySlice from "../slices/citySlice";
import eventSlice from "../slices/eventSlice";
import loginSlice from "../slices/loginSlice";
import notificationSlice from "../slices/notificationSlice";
import rewardSlice from "../slices/rewardSlice";
import storySlice from "../slices/storySlice";
import subCategorySlice from "../slices/subCategorySlice";
import twilioSlice from "../slices/twilioSlice";
import UserManagementSlice from "../slices/UserManagementSlice";
import userActivitySlice from "../slices/userActivitySlice";

const combinedReducer = combineReducers({
  // Auth reducers
  auth: authSlice,
  setting: settingSlice,
  login: loginSlice,
  notification: notificationSlice,

  // Common reducers
  tenant: tenantSlice,
  companyBrand: companyAndBrandSlice,
  companyIntegration: companyIntegrationSlice,
  courierConfiguration: courierConfigurationSlice,
  commonCustomer: commonCustomerSlice,
  marketing: marketingSlice,
  quote: quoteSlice,
  seo: seoSlice,
  website: websiteInfoSlice,
  websiteProductFeature: websiteProductFeatureSlice,
  websiteProduct: websiteProductSlice,
  customDomain: customDomainSlice,
  customizationChildren: customizationChildrenSlice,
  subscription: subscriptionSlice,
  websiteMetaData: websiteMetaDataSlice,

  // Ecommerce reducers
  dashboard: dashboardSlice,
  product: productSlice,
  productChildren: productChildrenSlice,
  productDesign: productDesignSlice,
  productDiscount: productDiscountSlice,
  productPreview: productPreviewSlice,
  review: ProductCustomerReviewSlice,
  coupon: couponSlice,
  courier: courierSlice,
  order: orderSlice,
  arShapes: arShapesSlice,
  commentRule: commentRuleSlice,
  adminNotification: adminNotifictionSlice,
  customer: customerSlice,
  productCategory: productCategorySlice,
  productFilter: productFilterSlice,
  productMetaData: productMetaDataSlice,
  offering: offeringSlice,
  offeringBookingReply: offeringBookingReplySlice,
  offeringChildren: offeringChildrenSlice,
  inventory: inventorySlice,
  instagram: instagramSlice,
  deliveryCharge: deliveryChargeSlice,
  gst: gstSlice,
  facebook: facebookSlice,
  quickReply: quickReplySlice,
  whatsapp: whatsappSlice,
  whatsappTemplate: whatsappTemplateSlice,

  // Legacy/root reducers
  reward: rewardSlice,
  story: storySlice,
  users: UserManagementSlice,
  userActivity: userActivitySlice,
  event: eventSlice,
  twilio: twilioSlice,
  categoryData: categoryDataSlice,
  subCategory: subCategorySlice,
  city: citySlice,
});

const rootReducer = (state, action) => {
  if (action.type === "login/setLoginFlag") {
    // check for action type
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
